export const CDN_URL = "https://cdn-crayo.com/lp/public";
